export default __webpack_public_path__ + "static/media/photo-cat-gif.b9c41d9a.mp4";